import getConfig from 'next/config';
import jsCookie from 'js-cookie';
import { HTTPClient } from '../api';

const { BASE_URL_MEDIA } = getConfig().publicRuntimeConfig;

export interface IKYCverification {
  ktp: string;
  passport: string;
  annualIncome: number;
  sourceOfFund: string;
}

const KycApiService = async (requestData, flag) => {
  let request = {};
  if (flag === 'adduser') {
    request = {
      method: 'POST',
      body: JSON.stringify(requestData),
    };
  }
  if (flag === 'updateuser') {
    const token = jsCookie.get('token');
    const personID = jsCookie.get('personID');

    const requestBody = {
      token: token,
      personId: personID,
      idCardType: requestData.ktp ? 'KTP' : 'Passport',
      annualIncome: requestData.annualIncome,
      sourceOfFund: requestData.sourceOfFund,
      citizenship: requestData.ktp ? 'WNI' : 'WNA',
    };
    if (requestData.ktp) {
      requestBody['identityCardNumber'] = requestData.ktp;
    } else {
      requestBody['passportNumber'] = requestData.passport;
    }
    request = {
      method: 'PATCH',
      body: JSON.stringify(requestBody),
    };
  }

  const res = await HTTPClient(`${BASE_URL_MEDIA}api/accounts/kyc/`, request);

  return res;
};

export default KycApiService;
